import Vue from 'vue'

// axios
import axios from 'axios'
import axiosRetry from 'axios-retry'

const axiosIns = axios.create({
  // You can add your headers here
  // ================================
  baseURL: process.env.VUE_APP_BASE_URL,
  // timeout: 1000,
  // headers: {'X-Custom-Header': 'foobar'}
})

Vue.prototype.$http = axiosIns

axiosRetry(axiosIns, {
  retries: 3,
  retryDelay: retryCount => retryCount * 2000,
})

export default axiosIns
